import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, Icon } from "semantic-ui-react";

const RetailerList = ({ retailers }) => {
  //const history = useHistory();
  const navigate = useNavigate(); 
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const handleClick = (retailer) => {
    navigate(`/admin/retailers?retailer=${retailer.name}`);
  };

  const handlePlus = () => {
    navigate("/admin/retailers?add=new");
  };

  return (
    <Menu vertical>
      <Menu.Item header>
        Retailers{" "}
        <Icon
          link
          name="plus"
          size="large"
          color="teal"
          onClick={handlePlus}
          title="Create new retailer"
        />
      </Menu.Item>
      {retailers.map((retailer) => (
        <Menu.Item
          name={retailer.name}
          onClick={() => handleClick(retailer)}
          active={query.get("retailer") === retailer.name}
          key={retailer.name}
          displayname={retailer.displayName}
        >
          {retailer.displayName}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default RetailerList;
